import React from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
import './about.css'

import { NetPost, NetGet } from '../../axios'
import { toast } from 'react-toastify'
import { reSetBar } from '../../tool/reSetBar';
import BoardTop from '../board/boardTop';
import LazyImg from '../../components/lazyimg';
import Data from '../board/data'
import { runhtml } from '../../tool/runtime'
import RightBox from '../../components/com_all/rightBox'
class About extends React.Component {
    state = {
        data: ""
    }
    componentDidMount() {
        document.title = "关于我 | 本站 ~ |"
        reSetBar()
        this.node.scrollIntoView();
        this.getData()
    }



    getData = () => {
        NetGet("./friendslink.json")
            .then((res) => {
                if (res.code == 0 && res.data.length > 0) {
                    this.setState({ data: res.data })
                }
            })
    }


    renderFrindList = (data) => {
        return data.map((e, i) => {
            return (
                <div key={"links" + i}>
                    <h3 className="link-title" >
                        <span className="fake-title">{e.typetilte}</span>
                    </h3>
                    <ul className="link-items fontSmooth">
                        {
                            e.data.length > 0
                            &&
                            e.data.map((ec, ic) =>
                                <li className="link-item" key={"eclinks" + ic}>
                                    <a className="link-item-inner effect-apollo" href={ec.links} title="Sanarous" target="_blank">
                                        <LazyImg loadimg="https://image.bestzuo.cn/images/20200621224833.gif!getwebp" className="lazyload" src={ec.headimg} />
                                        <span className="sitename">{ec.name}</span>
                                        <div className="linkdes">{ec.detalis}</div>
                                    </a>
                                </li>
                            )
                        }


                    </ul>
                </div>
            )
        })
    }

    render() {
        const { data } = this.state

        return (
            <div ref={node => this.node = node} className="allMargintop" style={{ marginBottom: 0 }}>
                <BoardTop
                    imgstyle={{ maxHeight: "155%", height: "unset" }}
                    loadimg="http://ningcat.com/siteasset/onloading/orange.progress-bar-stripe-loader.svg"
                    bgimg="http://ningcat.com/siteasset/bigimg/24b3489ddff60e2c6e3cc8118d031ad9.jpg"
                    title="关于我 | 本站"
                />



                <section id="content" className="outer row justify-content-center flex-row-reverse friendlink" style={{ margin: "auto",  }}>
                    <div className="rightbox">
                        <RightBox className="dark-bg" />
                    </div>
                    <div className="leftbox">
                        <div className="dark-bg">
                            <article className="links-tips">

                                <p >
                                    <h3 id="toc-head-1" className="entry-content">关于我</h3>
                                    基本：徐 | 男 | 97 | 重庆<br /><br />
                                    职业：大前端开发<br /><br />
                                    <div style={{ display: "flex" }}><div style={{ whiteSpace: "nowrap" }}>技术：</div><div>javascript | dart | nodejs | reactjs | react-native | flutter | cocos</div></div><br />
                                    爱好：猫 | 王者<br /><br />
                                    联系我：QQ微信同号 | 839650216</p>
                                <br />

                                <br />
                                <br />
                                <h3 id="toc-head-1" className="entry-content">关于本站</h3>
                                <p>

                                    ★ 服务器：百度云 <br />
                                    <br />
                                    ★ 后端：nodejs<br />
                                    <br />
                                    ★ 页面：使用reactjs仿的<a rel="me" href="https://github.com/mashirozx/Sakura/" target="_blank" style={{ color: "#f27210" }}>Sakura主题</a>和一些其他主题好看的样式<br />
                                    <br />
                                    <label
                                        style={{ lineHeight: 2, display: "block", color: "#e67474", fontWeight: 'bold', backgroundColor: "rgba(254,250,199,1)", padding: "6px", borderRadius: "5px", width: "100%" }}
                                    >
                                        之所以不用HTML,因为HTML每个路由，都得重新去请求页面结构，样式，js代码，跳转非常慢，
                             而react就不一样，你会发现每次跳转都没有拖拉（仅限站内，文章页除外，见下方遇到的坑），
                             特别适合服务器带宽慢的问题(跳转不用等待)，缺点是国内的百度爬不了js生成的页面结构。
                            </label>

                                </p>

                                <br />
                                <br />
                                <h3 id="toc-head-1" className="entry-content">开发遇到的坑</h3>
                                <p>
                                    <div style={{ lineHeight: 2, color: "#c78792", fontWeight: 'bold', backgroundColor: "#48443f", padding: "6px", borderRadius: "5px" }}>
                                        我只想说百度爬虫有待提高啊，竟然爬不了js生成的页面；<br />
                                        不得不说google还是很厉害的，不管是爬取效率，还是js页面；<br />
                                        所以我只能用服务器渲染文章页（使用nodejs同构，渲染react页面）。
                            </div>
                                </p>



                            </article>

                            <br /><br />
                            <div className="toc-container">
                                <div className="toc"></div>
                            </div>
                            <Data articleid={-2} />
                        </div>
                    </div>

                </section>
                {runhtml}
            </div>
        )
    }
}



export default connect()(About)